import { render, staticRenderFns } from "./CommentGrid.vue?vue&type=template&id=66ca3dc3&scoped=true"
import script from "./CommentGrid.vue?vue&type=script&lang=js"
export * from "./CommentGrid.vue?vue&type=script&lang=js"
import style0 from "./CommentGrid.vue?vue&type=style&index=0&id=66ca3dc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ca3dc3",
  null
  
)

export default component.exports